import { useEffect, useState } from 'react'
import styles from './SplashScreen.module.css'

interface SplashScreenProps {
  duration?: number
  onComplete: () => void
}

export function SplashScreen({ duration = 6000, onComplete }: SplashScreenProps) {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
      onComplete()
    }, duration)

    return () => clearTimeout(timer)
  }, [duration, onComplete])

  if (!isVisible) return null

  return (
    <div className={styles.splashContainer}>
      {/* OneDrive Loading Icon - Center (inline SVG, crisp at any size) */}
      <svg
        viewBox="0 0 24 24"
        className={styles.loadingIcon}
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Loading"
      >
        <defs>
          <linearGradient id="odCloud" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#28A8EA" />
            <stop offset="50%" stopColor="#0078D4" />
            <stop offset="100%" stopColor="#0364B8" />
          </linearGradient>
        </defs>
        <path
          fill="url(#odCloud)"
          d="M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
        />
      </svg>

      {/* Microsoft Logo - Bottom Center */}
      <img
        src="https://res.public.onecdn.static.microsoft/assets/framework/microsoft.svg"
        alt="Microsoft"
        className={styles.microsoftLogo}
      />
    </div>
  )
}
